import React from 'react';

function IntroMethod() {
    return (
        <div id="intromethodscss">
            <div id="container">
                <div className="contentTitle">
                    <div className="titleText">
                        <span className="eng">
                            <span className="colorT">PLAY</span>API
                        </span>{' '}
                        도입방법
                    </div>
                </div>
                <div className="contents">
                    <h3 className="sectionTitle">연동 진행 순서</h3>
                    <div className="stepList">
                        <div className="stepCon">
                            <p className="icon icon-step_icon01"></p>
                            <div className="textArea">
                                <p>도입상담</p>
                                상담신청
                                <br />
                                <span className="eng">API</span> 구조 소개
                            </div>
                        </div>
                        <div className="stepArrow">
                            <span className="icon-step-arrow"></span>
                            <span className="icon-step-arrow"></span>
                        </div>
                        <div className="stepCon">
                            <p className="icon icon-step_icon02"></p>
                            <div className="textArea">
                                <p>
                                    <span className="eng">API</span>검토 및 테스트
                                </p>
                                <span className="eng">API</span> 제공범위 협의 <br />
                                <span className="eng">API KEY</span> 발급 및 테스트
                            </div>
                        </div>
                        <div className="stepArrow">
                            <span className="icon-step-arrow"></span>
                            <span className="icon-step-arrow"></span>
                        </div>
                        <div className="stepCon">
                            <p className="icon icon-step_icon03"></p>
                            <div className="textArea">
                                <p>계약진행</p>
                                계약서 작성
                            </div>
                        </div>
                        <div className="stepArrow">
                            <span className="icon-step-arrow"></span>
                            <span className="icon-step-arrow"></span>
                        </div>
                        <div className="stepCon">
                            <p className="icon icon-step_icon04"></p>
                            <div className="textArea">
                                <p>개발진행</p>
                                <span className="eng">API</span> 연동개발
                            </div>
                        </div>
                        <div className="stepArrow">
                            <span className="icon-step-arrow"></span>
                            <span className="icon-step-arrow"></span>
                        </div>
                        <div className="stepCon">
                            <p className="icon icon-step_icon05"></p>
                            <div className="textArea">
                                <p>서비스 오픈</p>
                                <span className="eng">QA</span> <br />
                                서비스오픈
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contact bg-lightGray">
                    <p className="icon-icon_mail"></p>
                    <p className="title">도입 문의</p>
                    제휴문의
                    <span className="eng">
                        E-mail{' '}
                        <span style={{ fontWeight: 400 }}>
                            | <a href="mailto:playapi@playauto.co.kr">playapi@playauto.co.kr</a>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default IntroMethod;
